import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
const _excluded = ["format"];
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
import { toUrl } from "../utils.js";
const storyBlokAssets = /*#__PURE__*/_wrapRegExp(/(\/f\/\d+\/\d+x\d+\/\w+\/[^\/]+)\/?(m\/?(\d+x\d+:\d+x\d+)?\/?((\x2D)?(\d+)x(\x2D)?(\d+))?\/?(filters:([^\/]+))?)?$/g, {
  id: 1,
  modifiers: 2,
  crop: 3,
  resize: 4,
  flipx: 5,
  width: 6,
  flipy: 7,
  height: 8,
  filters: 10
});
const storyBlokImg2 = /*#__PURE__*/_wrapRegExp(/^(\/(\d+x\d+:\d+x\d+)?\/?((\x2D)?(\d+)x(\x2D)?(\d+))?\/?(filters:([^\/]+))?\/?)?(\/f\/.+)$/g, {
  modifiers: 1,
  crop: 2,
  resize: 3,
  flipx: 4,
  width: 5,
  flipy: 6,
  height: 7,
  filters: 9,
  id: 10
});
export const splitFilters = filters => {
  if (!filters) {
    return {};
  }
  return Object.fromEntries(filters.split(":").map(filter => {
    if (!filter) return [];
    const [key, value] = filter.split("(");
    return [key, value.replace(")", "")];
  }));
};
export const generateFilters = filters => {
  if (!filters) {
    return undefined;
  }
  const filterItems = Object.entries(filters).map(_ref => {
    let [key, value] = _ref;
    return key + "(" + (value !== null && value !== void 0 ? value : "") + ")";
  });
  if (filterItems.length === 0) {
    return undefined;
  }
  return "filters:" + filterItems.join(":");
};
export const parse = imageUrl => {
  const url = toUrl(imageUrl);
  // img2.storyblok.com is the old domain for Storyblok images, which used a
  // different path format. We'll assume custom domains are using the new format.
  const regex = url.hostname === "img2.storyblok.com" ? storyBlokImg2 : storyBlokAssets;
  const [matches] = url.pathname.matchAll(regex);
  if (!matches || !matches.groups) {
    throw new Error("Invalid Storyblok URL");
  }
  const {
    id,
    crop,
    width,
    height,
    filters,
    flipx,
    flipy
  } = matches.groups;
  const _splitFilters = splitFilters(filters),
    {
      format
    } = _splitFilters,
    filterMap = _objectWithoutPropertiesLoose(_splitFilters, _excluded);
  // We update old img2.storyblok.com URLs to use the new syntax and domain
  if (url.hostname === "img2.storyblok.com") {
    url.hostname = "a.storyblok.com";
  }
  return {
    base: url.origin + id,
    width: Number(width) || undefined,
    height: Number(height) || undefined,
    format,
    params: {
      crop,
      filters: filterMap,
      flipx: flipx,
      flipy: flipy
    },
    cdn: "storyblok"
  };
};
export const generate = _ref2 => {
  let {
    base,
    width = 0,
    height = 0,
    format,
    params = {}
  } = _ref2;
  const {
    crop,
    filters,
    flipx = "",
    flipy = ""
  } = params;
  const size = "" + flipx + width + "x" + flipy + height;
  return new URL([base, "m", crop, size, generateFilters(filters), format].filter(Boolean).join("/"));
};
export const transform = _ref3 => {
  let {
    url: originalUrl,
    width,
    height,
    format
  } = _ref3;
  const parsed = parse(originalUrl);
  if (!parsed) {
    return;
  }
  if (format) {
    if (!parsed.params) {
      parsed.params = {
        filters: {}
      };
    }
    if (!parsed.params.filters) {
      parsed.params.filters = {};
    }
    parsed.params.filters.format = format;
  }
  return generate(Object.assign({}, parsed, {
    width,
    height
  }));
};